import { render } from "./ProductGroupDiscountModal.vue?vue&type=template&id=19aa3c6f&ts=true"
import script from "./ProductGroupDiscountModal.vue?vue&type=script&lang=ts"
export * from "./ProductGroupDiscountModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__